export default "__VITE_ASSET__CwANC0d1__"